// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1_lHO","additionalInfo":"AgreementModal_additionalInfo__3DC-V"};